// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webchat-container, .webchat-container > * {
    width: 100%;
    max-width: 40vw;
    margin: 0 auto;
}
#web-chat, #web-chat > * {
    width: 100%;
    height: 100vh;
}

.web-background {
    flex: 1;
    justify-content: center;
	background: var(--chat-background);
}

.ac-pushButton.style-default { 
    background-color: white !important; 
    color: var(--main-tertiary-color) !important; 
} 

.ac-pushButton.style-default[aria-pressed="true"] { 
    background-color: var(--main-tertiary-color) !important; 
    color: white !important; 
} 

.ac-pushButton.style-default:hover { 
    background-color: var(--main-sub-color) !important; 
    color: white !important; 
}

.ac-textBlock {
    white-space: normal !important;
}

.webchat__bubble__content {
    border-radius: 3.5px 25px 25px !important;
    box-shadow: 1px 2px 1px 1px var(--main-tertiary-color) !important;
    margin: 5px !important;
}

.webchat__send-box__main {
    border-radius: 20px !important;
    border: 1px solid black !important;
}

.webchat__icon-button__shade {
    background-color: #e5e4e9 !important;
    border-radius: 50% !important;
    border: 1px solid rgba(28,110,164,.14) !important;
}

select:focus > option:hover { 
    background: var(--main-tertiary-color) !important;
    color: #fff !important;
}

select:focus > option:checked { 
    background: var(--main-tertiary-color) !important;
    color: #fff !important;
}

select option:checked{
    background-color: var(--main-tertiary-color) !important;
    color: #fff !important;
}

/* .webchat__send-box-text-box {
    border-radius: 20px;
    border: 1px solid black;
} */



@media only screen and (max-width: 600px) {
    .webchat-container, .webchat-container > * {
        width: 100vw;
        max-width: 100vw;
        min-height: 95vh;
        height: 95vh;
    }
    #web-chat, #web-chat > * {
        width: 100vw;
        min-height: 95vh;
        height: 95vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/webchat/WebChat.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,uBAAuB;CAC1B,kCAAkC;AACnC;;AAEA;IACI,kCAAkC;IAClC,4CAA4C;AAChD;;AAEA;IACI,uDAAuD;IACvD,uBAAuB;AAC3B;;AAEA;IACI,kDAAkD;IAClD,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,iEAAiE;IACjE,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;IACjD,sBAAsB;AAC1B;;AAEA;IACI,iDAAiD;IACjD,sBAAsB;AAC1B;;AAEA;IACI,uDAAuD;IACvD,sBAAsB;AAC1B;;AAEA;;;GAGG;;;;AAIH;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,YAAY;IAChB;AACJ","sourcesContent":[".webchat-container, .webchat-container > * {\r\n    width: 100%;\r\n    max-width: 40vw;\r\n    margin: 0 auto;\r\n}\r\n#web-chat, #web-chat > * {\r\n    width: 100%;\r\n    height: 100vh;\r\n}\r\n\r\n.web-background {\r\n    flex: 1;\r\n    justify-content: center;\r\n\tbackground: var(--chat-background);\r\n}\r\n\r\n.ac-pushButton.style-default { \r\n    background-color: white !important; \r\n    color: var(--main-tertiary-color) !important; \r\n} \r\n\r\n.ac-pushButton.style-default[aria-pressed=\"true\"] { \r\n    background-color: var(--main-tertiary-color) !important; \r\n    color: white !important; \r\n} \r\n\r\n.ac-pushButton.style-default:hover { \r\n    background-color: var(--main-sub-color) !important; \r\n    color: white !important; \r\n}\r\n\r\n.ac-textBlock {\r\n    white-space: normal !important;\r\n}\r\n\r\n.webchat__bubble__content {\r\n    border-radius: 3.5px 25px 25px !important;\r\n    box-shadow: 1px 2px 1px 1px var(--main-tertiary-color) !important;\r\n    margin: 5px !important;\r\n}\r\n\r\n.webchat__send-box__main {\r\n    border-radius: 20px !important;\r\n    border: 1px solid black !important;\r\n}\r\n\r\n.webchat__icon-button__shade {\r\n    background-color: #e5e4e9 !important;\r\n    border-radius: 50% !important;\r\n    border: 1px solid rgba(28,110,164,.14) !important;\r\n}\r\n\r\nselect:focus > option:hover { \r\n    background: var(--main-tertiary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\nselect:focus > option:checked { \r\n    background: var(--main-tertiary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\nselect option:checked{\r\n    background-color: var(--main-tertiary-color) !important;\r\n    color: #fff !important;\r\n}\r\n\r\n/* .webchat__send-box-text-box {\r\n    border-radius: 20px;\r\n    border: 1px solid black;\r\n} */\r\n\r\n\r\n\r\n@media only screen and (max-width: 600px) {\r\n    .webchat-container, .webchat-container > * {\r\n        width: 100vw;\r\n        max-width: 100vw;\r\n        min-height: 95vh;\r\n        height: 95vh;\r\n    }\r\n    #web-chat, #web-chat > * {\r\n        width: 100vw;\r\n        min-height: 95vh;\r\n        height: 95vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
